<template>
  <div
    v-interpolate
    class="text"
    v-html="useSanitizeHtml(text)"
  />
</template>

<script setup lang="ts">
import { vInterpolate } from '~/directives/v-interpolate.js'

defineProps<{
  text: string
}>()
</script>
